export default __webpack_public_path__ + "static/media/6_Maximiliano Viale_179x177.10c477ba.webp";